var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 35.1136C22.5513 35.8203 23.7194 36.25 25 36.25C26.2806 36.25 27.4487 35.8203 28.3333 35.1136M15.6345 31.4772C15.1075 31.4772 14.8132 30.6493 15.132 30.1893C15.8717 29.1219 16.5857 27.5564 16.5857 25.6712L16.6162 22.9396C16.6162 17.8643 20.3698 13.75 25 13.75C29.6984 13.75 33.5073 17.9249 33.5073 23.0749L33.4768 25.6712C33.4768 27.5694 34.1661 29.1434 34.8758 30.2112C35.1823 30.6724 34.8872 31.4772 34.3667 31.4772H15.6345Z",
    stroke: "#2D3036",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 10,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#25C277"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 10,
    width: 14,
    height: 14,
    rx: 7,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.6d581e45c13dbb3185679332889c4bd6.svg";
export { ForwardRef as ReactComponent };